import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'


const ECGType = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>ECG Type</InputLabel>
      <Select
        value={moduleValues?.['ECG Type'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({ ...prev, ['ECG Type']: e.target.value }))
        }
        label='ECG Type'
      >
        <MenuItem value='12-Lead'>12-Lead</MenuItem>
        <MenuItem value='3-Lead'>3-Lead</MenuItem>
        </Select>
    </FormControl>
  </Grid>
)

export default ECGType